import {
    SET_TIMER_VALUE_SUCCESS,
    SET_EVENT_AUDIO_VALUE_SUCCESS
} from './constants';

const timerPlayerState = {};
const soundPlayerState = {
    events: 'default',
    numberEvent: 0
};
/**
 *
 * @param state
 * @param action
 * @returns {*}
 */
const timerReducer = ( state = timerPlayerState, action ) => {
    switch ( action.type ) {
        case SET_TIMER_VALUE_SUCCESS : {
            return action.val;
        }
        default:
            return state;
    }
};
/**
 *
 * @param state
 * @param action
 * @returns {{numberEvent: number}|{numberEvent: number, events: string}}
 */
const soundReducer = ( state = soundPlayerState, action ) => {
    switch ( action.type ) {
        case SET_EVENT_AUDIO_VALUE_SUCCESS : {

            let evNumber = state.numberEvent + 1;
            let actionVal = { ...action.val, numberEvent: evNumber };
            return actionVal;
        }
        default:
            return state;
    }
};


export { timerReducer as gameprogress, soundReducer as eventSound };
